import React from 'react'
import { IonItemDivider, IonLabel, IonList, IonItem, IonCol, IonRow } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import AddPatientInformation from '../addPatientInformation/AddPatientInformation.component'
import { useDispatch, useSelector } from 'react-redux'
import { getHomeSelector } from '../../home/selectors/getHome.selector'
import PatientSearchButton from '../../patientSearch/patientSearchButton/patientSearchButton.component'
import { useHistory } from 'react-router'
import { getPatientInformationState } from '../selectors'
import ReplacePatientButton from '../replacePatient/ReplacePatientButton.component'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { IAlertState } from '../../../components/alert/store/alert.types'
import { replacePatient } from '../store/patientInformation.actions'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientSearchData } from '../../patientSearch/store/patientSearch.actions'

const PatientInformationMobile: React.FC = () => {
  const { t } = useTranslation()
  const { hideComponent } = useSelector(getHomeSelector)
  const { searchImport } = useSelector(getPatientInformationState)
  const history = useHistory()
  const dispatch = useDispatch()

  const showNotImplementedAlert = () => {
    alert('Not implemented')
  }

  const onPatientSearchClick = () => {
    dispatch(getPatientSearchData())
    history.push(TabConstants.PATIENT_SEARCH)
  }

  const handleYesReplacePatient = () => {
    dispatch(replacePatient())
    history.push(TabConstants.PATIENT_INFO_ROUTE)
  }

  const onReplaceButtonClick = () => {
    const alert: IAlertState = {
      header: t('patientDemographics.ReplacePatient'),
      message: t('patientDemographics.ReplacePatientAlertMessage'),
      buttons: [
        { text: t('common.buttons.Cancel') },
        { text: t('common.buttons.Yes'), role: 'destructive', handler: handleYesReplacePatient },
      ],
    }
    dispatch(showAlert(alert))
  }

  return (
    <>
      <IonItemDivider color='light' className='ion-padding-top'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('fullChart.patient.patientInformation.AddPatientInformation')}
        </IonLabel>
      </IonItemDivider>
      {!searchImport && <PatientSearchButton onClickAction={onPatientSearchClick}></PatientSearchButton>}
      {searchImport && <ReplacePatientButton onClickAction={onReplaceButtonClick}></ReplacePatientButton>}
      <AddPatientInformation />
      {hideComponent && (
        <>
          <IonItemDivider color='light' />
          <IonList>
            <IonItem onClick={showNotImplementedAlert}>
              <IonCol className='ion-padding'>
                <IonRow>
                  <IonLabel color='dark'>
                    <h2>{t('fullChart.patient.patientInformation.OtherPatientInformation')}</h2>
                  </IonLabel>
                </IonRow>
                <IonRow>
                  <IonLabel color='medium'>
                    <h3>{t('fullChart.patient.patientInformation.RelativeInfoImmunizationPhysician')}</h3>
                  </IonLabel>
                </IonRow>
              </IonCol>
            </IonItem>
          </IonList>
        </>
      )}
    </>
  )
}

export default PatientInformationMobile
